module.exports = __webpack_public_path__ + "static/media/JE.d9a33b19.svg";